{
  "form": {
    "editTitle": "Modifier : {{name}}",
    "createTitle": "Créer un nouveau jeu de critères",
    "nameLabel": "Nom des critères",
    "nameHelper": "Donnez un nom descriptif à ce jeu de critères",
    "nameRequired": "Le nom est requis",
    "priceRange": "Fourchette de prix (CHF)",
    "minPrice": "Prix minimum",
    "maxPrice": "Prix maximum",
    "priceMaxError": "Le prix maximum doit être supérieur ou égal au prix minimum",
    "sizeRange": "Surface du bien (m²)",
    "minSize": "Surface minimum",
    "maxSize": "Surface maximum",
    "sizeMaxError": "La surface maximum doit être supérieure ou égale à la surface minimum",
    "roomsRange": "Nombre de pièces",
    "minRooms": "Pièces minimum",
    "maxRooms": "Pièces maximum",
    "roomsMaxError": "Le nombre maximum de pièces doit être supérieur ou égal au minimum",
    "priceNonNegative": "Le prix doit être positif ou nul",
    "sizeNonNegative": "La surface doit être positive ou nulle",
    "roomsPositive": "Le nombre de pièces doit être positif",
    "locationTitle": "Localisation",
    "locationField": "Localisation (séparée par des virgules)",
    "locationHelper": "ex. Lausanne, Genève, Vaud",
    "saving": "Enregistrement...",
    "update": "Mettre à jour les critères",
    "create": "Créer les critères"
  },
  "list": {
    "emptyMessage": "Aucun jeu de critères configuré pour le moment. Créez-en un pour commencer à suivre des biens.",
    "createButton": "Créer un jeu de critères",
    "newButton": "Nouveau jeu de critères",
    "count_one": "{{count}} jeu de critères",
    "count_many": "{{count}} jeux de critères",
    "count_other": "{{count}} jeux de critères",
    "active": "Actif",
    "inactive": "Inactif",
    "noFilters": "Aucun filtre configuré",
    "any": "Indifférent",
    "rooms": "pièces",
    "updated": "Mis à jour : {{date}}",
    "deleteTitle": "Supprimer le jeu de critères",
    "deleteConfirm": "Voulez-vous vraiment désactiver « {{name}} » ? Ce jeu de critères ne sera plus utilisé pour filtrer les annonces."
  },
  "display": {
    "title": "Critères de recherche actuels",
    "emptyMessage": "Aucun critère de recherche configuré pour le moment. Utilisez le formulaire ci-dessous pour définir vos préférences.",
    "price": "Prix (CHF)",
    "size": "Surface (m²)",
    "rooms": "Pièces",
    "location": "Localisation",
    "any": "Indifférent",
    "lastUpdated": "Dernière mise à jour : {{date}}"
  },
  "page": {
    "title": "Configuration des critères de recherche",
    "description": "Gérez les jeux de critères de filtrage pour les recherches de biens. Chaque jeu définit une combinaison de filtres de prix, surface, pièces et localisation.",
    "updated": "Critères mis à jour avec succès !",
    "created": "Critères créés avec succès !",
    "deactivated": "Jeu de critères désactivé."
  }
}
